site.calendar = {
	view: function () {
		if ($('.content .images .image').length > 1) {
			site.owl.init('.content .images', {
				loop: false,
				nav: true,
				navText: ["", ""],
				autoHeight: true,
				items: 1,
				autoplay: false,
				onInitialized: function () {
					$('.owl-prev').after('<div class="num" />');
					site.calendar.updateNum();
				},
				onTranslated: function () {
					site.calendar.updateNum();
				}
			});
		}
	},

	updateNum: function () {
		var totalItems = $('.owl-item').length;
		var currentIndex = $('.owl-item.active').index() + 1;
		$('.num').html('' + currentIndex + '/' + totalItems + '');
	},

	day: '',
	town: '',
	category: 'all',
	listView: function () {
		var $events = $('.event__single'),
			$filtered = $events,
			$categories = $('a', '.categories'),
			$layout = $('> .content', '.boxText').data('layout');

		//Area print
		$('a.print').on('click', function (e) {
			e.preventDefault();
			var $wrap = $(this).closest('.eventsWrapper');
			$wrap.printThis({
				debug: false, // show the iframe for debugging
				bodyWrap: '<div id="calendar" class="list"><div class="content"></div></div>',
			});
		});

		//Hide towns with no events
		$('option', '#townSelect').each(function () {
			var townName = $(this).data('codename');
			if (townName) {
				var eventCount = $('.event__single.' + townName).length;
				if (eventCount === 0) {
					$(this).remove();
				}
			}
		});

		//Remove town selector if there are no towns
		if ($('option', '#townSelect').length === 1) {
			$('#townSelect').closest('.elm_select').remove();
		}

		//Town selector url changes
		$('#townSelect').on('change', function () {
			site.calendar.town = $(this).val();
			site.calendar.changeUrl();
			return false;
		});

		//Categories select url change, without page jump
		$categories.on('click', function (e) {
			e.preventDefault();
			site.calendar.category = $(this).data('codename');
			site.calendar.changeUrl();

		});

		//Day view
		if ($layout === 'day') {
			site.calendar.dayView();
		}

		$(window).bind('hashchange', function (e) {
			var hash = location.hash.substr(1);
			var fragments = hash.split('|');
			if (fragments.length === 1 && fragments[0] === '') {
				fragments = [];
			}

			//Day view
			if ($layout === 'day') {
				if (hash === '' || hash.indexOf('id-') === -1) {
					var url = (location.hash !== '' ? location.hash + '|' : '')
						+ $('.eventsWrapper:first-child').data('id');
					site.calendar.changeUrlByDay(url);
				}
			}

			//Filter the events
			var h = hash.replace(/\|/g, '.');
			site.calendar.filterEvents($events, $filtered.filter('.' + (h ? h : 'event__single')));

			if ($layout !== 'day') {
				//Update datepart links hash
				$('a', '.datePart').each(function () {
					$(this).attr('href', $(this).attr('href').replace(/#.*/, '') + location.hash);
				});
			}

			if (fragments.length > 0) {
				$.each(fragments, function (index, value) {
					if ($('.eventsWrapper[data-id=' + value).length > 0) {
						site.calendar.day = value;
					}
					else if ($('.' + value, '#townSelect').length > 0) {
						site.calendar.town = value;
						$('option[value="' + site.calendar.town + '"]', '#townSelect').attr('selected', 'selected');
					}
					else if ($('.' + value, '.categories').length > 0) {
						site.calendar.category = value;
					}
				});
			}
			else {
				site.calendar.day = '';
				site.calendar.resetFilters();
			}

			//Set selected category
			$categories.removeClass('selected');
			if (!site.calendar.category) {
				site.calendar.category = 'all';
			}
			$('.' + site.calendar.category, '.categories').addClass('selected');

		})
			.trigger('hashchange')
			.load(function () {
				$('img.responsive', '#calendar.list').responsiveImg({threshold: $(document).height()});
			});
		$('body').addClass('loaded');
	},

	filterEvents: function ($events, $filtered) {
		if ($filtered) {
			$events.addClass('hide');
			$filtered.removeClass('hide');
		}
		else {
			$events.removeClass('hide');
		}

		$('.eventsWrapper').removeClass('hide').each(function () {
			var $this = $(this);
			var hiddenEvents = $('.event__single.hide', $this).length;
			var eventCount = $('.event__single', $this).length;
			if (hiddenEvents === eventCount) {
				$this.addClass('hide');
			}
		});

		if ($('.eventsWrapper:not(.hide)').length === 0) {
			site.calendar.onNoEventsToShow();
		}
		else {
			$('body').removeClass('noEvents');
		}
	},

	dayView: function () {
		//Create day controls
		$('.viewControls').after('<div id="dayControls" />');
		var $dayControls = $('#dayControls');
		$dayControls.append('<span class="lmnt" id="datePicker"><input type="text" readonly="true" /></span>')
			.append('<a href="#" aria-label="Prev" class="prev"><i class="fa fa-chevron-circle-left" aria-hidden="true"></i></a>')
			.append('<a href="#" aria-label="Next" class="next"><i class="fa fa-chevron-circle-right" aria-hidden="true"></i></a>');

		//Setup datepicker
		$('input', '#datePicker').datepicker({
			dateFormat: "yy-mm-dd",
			beforeShowDay: function (date) {
				if ($.inArray(date.toISOString().slice(0, 10), site.calendar.getAvailableDates()) !== -1) {
					return [true, "enabled", ""];
				} else {
					return [false, "disabled", ""];
				}
			},
			beforeShow: function() {
				if (!$(this).hasClass('focus')) {
					$(this).addClass('focus');
				}
			},
			onClose: function() {
				if ($(this).hasClass('focus')) {
					$(this).removeClass('focus');
				}
			},
			onSelect: function (dateText, inst) {
				if (dateText !== '') {
					site.calendar.changeUrlByDay('id-' + dateText);
				}

			}
		});

		//Setup prev / next arrows
		$('a', '#dayControls').on('click', function (e) {
			e.preventDefault();

			var $wrapper = $('.eventsWrapper:not(.hide)'),
				$this = $(this),
				$new = $this.hasClass('prev') ? $wrapper.prev() : $wrapper.next();

			$this.removeClass('disabled');
			$this.siblings().removeClass('disabled');


			if ($new.length === 0) {
				$this.addClass('disabled');
			}
			else {
				var dateInputField = $('#dayControls input');
				if (dateInputField.length) {
					dateInputField.val($new.data('id').substr(3, $new.data('id').length));
				}
				site.calendar.changeUrlByDay($new.data('id'))
			}
		});
	},

	getAvailableDates: function () {
		var availableDates = [];

		$('.eventsWrapper').each(function () {
			availableDates.push($(this).data('id').replace('id-', ''));
		});
		return availableDates;
	},

	changeUrlByDay: function (id) {
		var url = [id];
		if (site.calendar.town) {
			url.push(site.calendar.town)
		}
		if (site.calendar.category && site.calendar.category !== 'all') {
			url.push(site.calendar.category);
		}
		location.hash = url.join('|');
	},

	changeUrl: function () {
		var url = [];
		if (site.calendar.day) {
			url.push(site.calendar.day)
		}
		if (site.calendar.town) {
			url.push(site.calendar.town);
		}
		if (site.calendar.category && site.calendar.category !== 'all') {
			url.push(site.calendar.category);
		}
		var scrollTop = $(window).scrollTop();
		location.hash = url.join('|');
		window.scrollTo(0, scrollTop);
	},

	onNoEventsToShow: function () {
		var $noEvents = $('#noEvents');
		if ($noEvents.innerHTML === undefined) {
			$noEvents.html($noEvents.data('value'));

			//Reset filter
			$('a', '#noEvents').on('click', function (e) {
				e.preventDefault();
				site.calendar.resetFilters();
				location.hash = site.calendar.day;
			});
		}
		$('body').addClass('noEvents');
	},

	resetFilters: function () {
		site.calendar.town = '';
		site.calendar.category = 'all';
	}

};
